import { render, staticRenderFns } from "./natural-in-store-customer-list.vue?vue&type=template&id=67831d1e&scoped=true&"
import script from "./natural-in-store-customer-list.vue?vue&type=script&lang=js&"
export * from "./natural-in-store-customer-list.vue?vue&type=script&lang=js&"
import style0 from "./natural-in-store-customer-list.vue?vue&type=style&index=0&id=67831d1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67831d1e",
  null
  
)

export default component.exports